const historyKey = 'sanjar-luxe:recently-viewed';
const validHandle = value => typeof value === 'string' && /^[a-z0-9-]+$/.test(value);
export function previousProducts(items, current, limit) {
  return [...new Set(Array.isArray(items) ? items.filter(validHandle) : [])].filter(item => item !== current).slice(0, limit);
}
class SanjarRecentlyViewed extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const current = this.dataset.current;
    if (!validHandle(current)) return;
    let stored = [];
    try {
      stored = JSON.parse(localStorage.getItem(historyKey) || '[]');
      this.handles = previousProducts(stored, current, Number(this.dataset.limit) || 4);
      localStorage.setItem(historyKey, JSON.stringify([current, ...previousProducts(stored, current, 15)]));
    } catch { this.handles = []; }
    if (!this.handles.length) return;
    if (!('IntersectionObserver' in window)) { this.load(); return; }
    this.observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      this.observer.disconnect(); this.load();
    }, { rootMargin: '400px' });
    this.observer.observe(this);
  }
  async load() {
    const signal = this.abort.signal;
    const root = window.Shopify?.routes?.root || '/';
    const results = await Promise.allSettled(this.handles.map(async handle => {
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=sanjar-recent-card`, { signal });
      if (!response.ok) throw new Error('Product unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      return document.querySelector('[data-sl-recent-card] product-card');
    }));
    if (signal.aborted || !this.isConnected) return;
    const cards = results.filter(result => result.status === 'fulfilled' && result.value).map(result => result.value);
    if (!cards.length) return;
    this.querySelector('[data-sl-recent-grid]').replaceChildren(...cards);
    this.querySelector('section').hidden = false;
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
}
if (!customElements.get('sl-recently-viewed')) customElements.define('sl-recently-viewed', SanjarRecentlyViewed);
